import React, {useContext} from 'react'
import {StateContext} from '../../context/GlobalState.jsx'
import {useParams} from 'react-router-dom'
import {GetText} from "../../context/text.js";
import {Helmet} from "react-helmet";


function ProductDetail() {
    window.scrollTo({ top: 0, behavior: 'smooth' })

    let {addToCart, courseUSD, lang} = useContext(StateContext);

    let text = GetText();

    let {productPartNumber} = useParams();

    // fetch all products data
    const {products} = useContext(StateContext)

    // filter the product with matching id
    const thisProduct = products.filter(product => product.PART_NUMBER === productPartNumber)


    /*const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);*/

    // render JSX
    return (
        // map all information of that specific product
        <section>
            <div className="topInfoProduct"> <p className="nomargin" >{text.ProductDetail.searchPart} <b>{productPartNumber}</b>: {thisProduct.length}{text.ProductDetail.count}</p></div>
            {thisProduct.length > 0 ? thisProduct.map(product => {
                return (
                    <div>
                        <div key={product.ID} className="product-detail">

                            { lang === "ua" ? <Helmet>
                                <title>{product.NAME_UA} | {product.MANUFACTURER} | {product.PART_NUMBER} -
                                    zapauto.com.ua</title>
                                <meta name="description" content={
                                    product.NAME_UA + ', ' + product.MANUFACTURER + ', ' + product.PART_NUMBER
                                }/>
                                <meta name="keywords"
                                      content={product.NAME_UA + ', ' + product.MANUFACTURER + ', ' + product.PART_NUMBER}/>
                            </Helmet> : ""}


                            { lang === "ru" ? <Helmet>
                                <title>{product.NAME_RU} | {product.MANUFACTURER} | {product.PART_NUMBER} -
                                    zapauto.com.ua</title>
                                <meta name="description" content={
                                    product.NAME_RU + ', ' + product.MANUFACTURER + ', ' + product.PART_NUMBER
                                }/>
                                <meta name="keywords"
                                      content={product.NAME_RU + ', ' + product.MANUFACTURER + ', ' + product.PART_NUMBER}/>
                            </Helmet> : ""}

                            { lang === "en" ? <Helmet>
                                <title>{product.NAME_EN} | {product.MANUFACTURER} | {product.PART_NUMBER} -
                                    zapauto.com.ua</title>
                                <meta name="description" content={
                                    product.NAME_EN + ', ' + product.MANUFACTURER + ', ' + product.PART_NUMBER
                                }/>
                                <meta name="keywords"
                                      content={product.NAME_EN + ', ' + product.MANUFACTURER + ', ' + product.PART_NUMBER}/>
                            </Helmet> : ""}




                            <div className="product-detail-image">


                                    {product.PHOTO == "" ?
                                        <img
                                            src="https://zapauto.com.ua/backend/public/images/logo-zapauto.png"
                                            title={product.NAME_UA}
                                            alt="product"
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                transition: 'transform 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                        />
                                        :
                                        <img
                                            src={product.PHOTO.replace("../", "https://zapauto.com.ua/")}
                                            title={product.NAME_UA}
                                            alt="product"
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                transition: 'transform 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                        />
                                    }


                            </div>

                            { lang === "ua" ?  <div className="product-detail-info">
                                <h4><b>{product.MANUFACTURER}</b> | <b>{product.PART_NUMBER}</b></h4>
                                <h4>{product.NAME_UA}</h4>
                                {/* product price */}
                                <h4 style={{ color: 'green', fontWeight: 'bold', marginTop: '10px' }}><b>{product.PRICE_USD * courseUSD}.00 грн</b></h4>
                                <button
                                    onClick={() => addToCart(product)}
                                    className="add-cart-btn"
                                    style={{
                                        fontSize: '18px', /* збільшений розмір шрифту */
                                        fontWeight: 'bold', /* жирний текст */
                                        padding: '12px 30px', /* більші відступи для збільшення кнопки */
                                    }}
                                >
                                    {text.ProductDetail.cartButton}
                                </button>

                                <div>

                                    <h5 style={{ color: 'green', fontWeight: 'bold', marginTop: '10px' }}>{text.ProductDetail.stock}</h5>
                                    <h5 style={{  fontWeight: 'bold', marginTop: '10px' }} > {product.CONDITION == 1 ? text.ProductDetail.conditionOld : text.ProductDetail.conditionNew }</h5></div>

                            </div> : ""}

                            { lang === "ru" ?  <div className="product-detail-info">
                                <h4><b>{product.MANUFACTURER}</b> | <b>{product.PART_NUMBER}</b></h4>
                                <h4>{product.NAME_RU}</h4>
                                {/* product price */}
                                <h4 style={{ color: 'green', fontWeight: 'bold', marginTop: '10px' }}><b>{product.PRICE_USD * courseUSD}.00 грн</b></h4>
                                <button
                                    onClick={() => addToCart(product)}
                                    className="add-cart-btn"
                                    style={{
                                        fontSize: '18px', /* збільшений розмір шрифту */
                                        fontWeight: 'bold', /* жирний текст */
                                        padding: '12px 30px', /* більші відступи для збільшення кнопки */
                                    }}
                                >
                                    {text.ProductDetail.cartButton}
                                </button>
                                <div>

                                    <h5 style={{ color: 'green', fontWeight: 'bold', marginTop: '10px' }}>{text.ProductDetail.stock}</h5>
                                    <h5 style={{  fontWeight: 'bold', marginTop: '10px' }} > {product.CONDITION == 1 ? text.ProductDetail.conditionOld : text.ProductDetail.conditionNew }</h5></div>

                            </div> : ""}

                            { lang === "en" ?  <div className="product-detail-info">
                                <h4><b>{product.MANUFACTURER}</b> | <b>{product.PART_NUMBER}</b></h4>
                                <h4>{product.NAME_EN}</h4>
                                {/* product price */}
                                <h4 style={{ color: 'green', fontWeight: 'bold', marginTop: '10px' }}><b>{product.PRICE_USD * courseUSD}.00 UAH</b></h4>
                                <button
                                    onClick={() => addToCart(product)}
                                    className="add-cart-btn"
                                    style={{
                                        fontSize: '18px', /* збільшений розмір шрифту */
                                        fontWeight: 'bold', /* жирний текст */
                                        padding: '12px 30px', /* більші відступи для збільшення кнопки */
                                    }}
                                >
                                    {text.ProductDetail.cartButton}
                                </button>
                                <div>

                                    <h5 style={{ color: 'green', fontWeight: 'bold', marginTop: '10px' }}>{text.ProductDetail.stock}</h5>
                                    <h5 style={{  fontWeight: 'bold', marginTop: '10px' }} > {product.CONDITION == 1 ? text.ProductDetail.conditionOld : text.ProductDetail.conditionNew }</h5></div>

                            </div> : ""}



                        </div>

                        <div className="product-detail-info product-card">


                            <div>
                                <div className="block_subtitle"><strong>{text.ProductDetail.dostavka}</strong></div>
                                <ul>
                                    <li>{text.ProductDetail.desc1}</li>
                                    <li>{text.ProductDetail.desc2}</li>
                                </ul>
                            </div>

                            <div>
                                <div className="block_subtitle"><strong>{text.ProductDetail.oplata}</strong></div>
                                <ul>
                                    <li>{text.ProductDetail.desc3}</li>
                                    <li>{text.ProductDetail.desc4}</li>
                                    <li>{text.ProductDetail.desc5}</li>
                                </ul>
                            </div>

                            <div>
                                <div className="block_subtitle"><strong>{text.ProductDetail.protovar}</strong></div>
                                <ul>
                                <li>{text.ProductDetail.desc6}</li>
                                <li>{text.ProductDetail.desc7}</li>
                                </ul>
                            </div>


                        </div>
                    </div>
                )
            }) : <div className="center-text items padTop">Loading...</div>}


        </section>
    )
}

export default ProductDetail
